import { Visibility, VisibilityOff } from "@material-ui/icons";
import { Button, IconButton, InputAdornment, TextField } from "@mui/material";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

toast.configure();
const toasterOption = {
    position: "bottom-center",
    autoClose: 2000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined
};

const initialFormValue = {
    phone_number: "",
    password: "",
};

export default function AgentLogin() {
    const navigate = useNavigate();
    const [formData, setFormData] = useState(initialFormValue);
    const [validateError, setValidateError] = useState({});

    const handleChange = (e) => {
        const { name, value } = e.target;

        // Only allow digits
        if (/^\d*$/.test(value)) {
            setFormData(prev => ({ ...prev, [name]: value }));

            // Validate as user types
            if (value.length === 10) {
                setValidateError({});
            } else if (value.length > 0 && value.length !== 10) {
                setValidateError({ phone_number: "Mobile number must be exactly 10 digits" });
            } else {
                setValidateError({});
            }
        }
    };

    const validateForm = () => {
        const errors = {};

        if (!formData.phone_number) {
            errors.phone_number = "Mobile number is required";
        } else if (formData.phone_number.length !== 10) {
            errors.phone_number = "Mobile number must be exactly 10 digits";
        } else if (!/^\d{10}$/.test(formData.phone_number)) {
            errors.phone_number = "Please enter a valid mobile number";
        }

        setValidateError(errors);
        return Object.keys(errors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validateForm()) {
            toast.error("Please enter a valid mobile number", toasterOption);
            return;
        }

        // TODO: Add your login API call here
        // const response = await agentLogin({ phone_number: formData.phone_number });

        // For now, just navigate to agent dashboard
        toast.success("Login successful", toasterOption);
        navigate("/agent/profile");
    };

    const handlePwdChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const [showPassword, setShowPassword] = React.useState(false);
    const toggleShowPassword = () => setShowPassword((prev) => !prev);

    return (
        <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '70vh',
            background: '#ffffff'
        }}>
            <div style={{
                background: 'white',
                padding: '40px',
                width: '100%',
                maxWidth: '450px'
            }}>
                <h2 className="font-great-vibes" style={{
                    textAlign: 'center',
                    color: '#B21919',
                }}>
                    Agent Login
                </h2>

                <form onSubmit={handleSubmit}>
                    <div style={{ margin: "1.5em 0" }}>
                        <TextField
                            fullWidth
                            label="Mobile Number"
                            name="phone_number"
                            value={formData.phone_number}
                            onChange={handleChange}
                            error={!!validateError.phone_number}
                            helperText={validateError.phone_number}
                            variant="outlined"
                            placeholder="Enter 10 digit mobile number"
                            inputProps={{
                                maxLength: 10,
                            }}
                            FormHelperTextProps={{
                                style: { fontSize: "14px", color: "red" },
                            }}
                            InputLabelProps={{
                                sx: {
                                    ".MuiInputLabel-asterisk": {
                                        color: "red",
                                        fontSize: "1.2em",
                                    }
                                }
                            }}
                            sx={{
                                '& .MuiInputBase-input': {
                                    fontSize: '18px',
                                }
                            }}
                            required
                        />
                    </div>

                    <div style={{ margin: "1em 0" }}>
                        <TextField
                            fullWidth
                            type={showPassword ? "text" : "password"}
                            label="Password"
                            name="password"
                            value={formData.password}
                            onChange={handlePwdChange}
                            error={!!validateError.password}
                            helperText={validateError.password}
                            variant="outlined"
                            FormHelperTextProps={{ style: { fontSize: "14px", color: "red" } }}
                            sx={{ '& .MuiInputBase-input': { fontSize: '16px' } }}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton onClick={toggleShowPassword} edge="end">
                                            {showPassword ? <VisibilityOff /> : <Visibility />}
                                        </IconButton>
                                    </InputAdornment>
                                ),
                            }}
                        />

                    </div>

                    <div style={{ margin: "1em 0" }}>
                        <Button
                            type="submit"
                            variant="contained"
                            fullWidth
                            style={{
                                padding: "14px",
                                fontSize: "1.2rem",
                                fontWeight: "bold",
                                borderRadius: "6px",
                                background: "#B21919",
                                color: "#FFFFFF",
                            }}
                        >
                            Login
                        </Button>
                    </div>

                    <div style={{ textAlign: 'center', marginTop: '20px' }}>
                        <p style={{ color: '#666', fontSize: '16px' }}>
                            Don't have an account?{' '}
                            <a
                                href="/agent/register"
                                style={{ color: '#B21919', textDecoration: 'none', fontWeight: 'bold' }}
                            >
                                Register here
                            </a>
                        </p>
                    </div>
                </form>
            </div>
        </div>
    );
}
